export const IS_DEV = process.env.IS_DEV !== undefined ? process.env.IS_DEV === 'true' : process.env.NODE_ENV !== 'production'

export const BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : 'http://localhost:3000'
export const SERVER = IS_DEV ? 'http://localhost:3000' : BASE_URL

export const SITE_NAME = 'AUM'
export const SITE_DESCRIPTION = 'AUM structures allocated UAEGD gold bars off balance sheet in a regulated, Sharia-compliant trust and tokenizes them 1:1 to enable transfer and settlement.'
export const SITE_SOCIAL_IMAGE = '/social-preview.jpg'
export const SITE_THEME_COLOR = '#201914'

export const ALLOW_ROBOTS = process.env.ALLOW_ROBOTS || true
export const PASSWORD_PROTECT = process.env.PASSWORD_PROTECT || false
export const SSR_BUILD = process.env.PASSWORD_PROTECT ? false : process.env.SSR_BUILD || true
